common:
  save: Lưu
animations:
  stage-transitions:
    title: Tắt hiệu ứng chuyển cảnh
  use-page-specific-transitions:
    description: >-
      Một số trang sẽ có hiệu ứng chuyển cảnh riêng, điều này sẽ ghi đè hiệu ứng chuyển cảnh mặc định
    title: Dùng hiệu ứng chuyển cảnh riêng cho từng trang
dialogs:
  onboarding:
    official:
      title: Nhà cung cấp chính thức của Aura
    title: Chào mừng đến với Aura!
    description: Hãy thiết lập nhà cung cấp AI đầu tiên để bắt đầu.
    enter: Vào
    validationRunning: Đang chạy các bài kiểm tra
    validationSuccess: Xác thực cấu hình thành công
    validationPartial: Cấu hình đã được xác thực một phần
    validationFailed: Xác thực cấu hình thất bại
    validationError: 'Lỗi xác thực: {error}'
    testGeneration: Ping API
    testGenerationRunning: Ping...
    testGenerationFailed: Ping test thất bại
    retryPingCheck: Thử lại
    next: Tiếp
    retry: Thử lại
    loginPrompt: Đăng nhập để sử dụng nhà cung cấp Aura chính thức để có trải nghiệm tốt nhất.
    loginAction: Đăng nhập
    flux: Flux
    buyFlux: Mua Flux
    permissions:
      title: Thông báo
      description: Bạn có thể cho phép thông báo ngay bây giờ hoặc tiếp tục và chỉnh lại sau.
      notificationsTitle: Thông báo
      notificationsDescription: Cho phép nhắc nhở và các cập nhật trạng thái quan trọng.
      notificationsAction: Yêu cầu quyền thông báo
      notificationsNotGrantedHint: Nếu từ chối, bạn có thể bật thông báo ở Cài đặt iOS.
      openSettings: Mở Cài đặt iOS
      optionalHint: Bạn có thể tiếp tục kể cả khi quyền thông báo không được cấp quyền.
      stateUnknown: Không được yêu cầu
      stateRequesting: Đang yêu cầu...
      stateGranted: Đã cấp quyền
      stateNotGranted: Khônh được cấp quyền
  bug-report:
    title: Báo lỗi (´;ω;`)ヾ(･∀･`)
    subtitle: Úi, xin lỗi nếu chúng tôi đã làm gì sai. Nếu không phiền thì bạn có thể kể cho chúng tôi biết chuyện gì đã xảy ra không?
    trigger-label: Báo lỗi
    submit-label: Gửi báo cáo lỗi
    triage-description: Bao gồm ảnh chụp màn hình và nội dung trang để giúp chúng tôi phân loại sự cố này.
    description-placeholder: Các bước để tái hiện, kết quả mong đợi và kết quả đã xảy ra
    include-current-page-screenshot: Bao gồm ảnh chụp màn hình trang hiện tại
    manual-media:
      label: Chọn các ảnh chụp màn hình / quay màn hình
      optional: Tùy chọn.
    media-files:
      label: Tệp đa phương tiện
      description: 'Không bắt buộc: chọn thủ công.'
      placeholder: Chọn ảnh chụp màn hình hoặc tệp video
      selected-count: '{count} tệp đã được chọn'
    last-submitted-preview: Xem Trước Payload Đã Gửi
language:
  title: Ngôn ngữ
  description: |
    Ngôn ngữ giao diện. Bạn có thể chỉnh ngôn ngữ nhân vật sau.
controls-island:
  icon-size:
    title: Kích thước biểu tượng đảo
    description: Điều chỉnh kích thước biểu tượng trên đảo điều khiển
    auto: Tự động (thích ứng)
    large: Lớn (mặc định)
    small: Nhỏ
analytics:
  notice:
    title: Phân tích dữ liệu sử dụng
    description: >-
      Aura thu thập dữ liệu sử dụng một cách ẩn danh để giúp chúng tôi hiểu cách ứng dụng được dùng và cải thiện sử ổn định. Không có dữ liệu cá nhân nào được thu thập.
    privacyPrefix: Đọc
    privacyLink: chính sách quyền riêng tư
    onboardingHint: Bạn có thể tắt phân tích ở Cài đặt > Hệ thống > Chung.
    settingsHint: Bạn có thể tắt phân tích bất cứ lúc nào.
  toggle:
    title: Bật phân tích dữ liệu sử dụng
    description: Tắt để từ chối việc thu thập phân tích dữ liệu.
  disabled:
    title: Phân tích dữ liệu bị vô hiệu hóa đối với bản dành cho nhà phát triển này
model-select:
  panel-callout:
    support-status-header: Chúng tôi hỗ trợ cả mô hình 2D và 3D
    support-status: >
      Click {select-button} to select or import models. Currently, {zip} (for Live2D and Spine models), {vrm} (for VRM models), and {mmd} (for MMD models, zipped with their textures) are supported.
    model-type-example: >
      Neuro-sama sử dụng mô hình 2D được vận hành bởi framework được phát triển bởi Live2D Inc, trong khi đó Grok Ani (trong Grok Companion) sử dụng mô hình 3D được vận hành bởi VRM /MMD định dạng mở.
  select-model:
    title: Chọn Mô Hình
    button: Chọn mô hình
    select: Chọn
    import: Nhập
    remove: Xóa
    confirm: Xác nhận
live2d:
  change-model:
    from-file: Tải từ tệp
    from-file-select: Chọn
    from-url: Tải từ URL
    from-url-confirm: Tải
    from-url-placeholder: Nhập URL mô hình Live2D
    title: Đổi mô hình
  edit-motion-map:
    title: Chỉnh bản đồ chuyển động
  map-motions:
    play: Phát chuyển động
    title: Gán chuyển động
  title: Cài đặt Live2D
  scale-and-position:
    title: Tỉ lệ và vị trí
    scale: Tỉ lệ
    x: X
    'y': 'Y'
  switch-to-vrm:
    title: Chuyển sang mô hình 3D?
    change-to-vrm: Bấm vào đây để đổi sang cài đặt mô hình 3D (VRM)
  theme-color-from-model:
    title: Trích xuất màu từ mô hình
    description: >
      Xuất các màu nổi bật từ canvas đang render hiện tại. Nhấp vào màu và áp dụng nó lên Aura. Thử xuất nhiều lần với mô hình theo nhiều tư thế khác nhau nếu màu sắc chưa được như mong muốn.
    button-extract:
      title: Trích xuất
  animation:
    title: Hoạt ảnh
    focus:
      title: Bật theo dõi chuột
      description: Nhìn vào con trỏ chuột trong khi nó di chuyển. Chuyển động mắt khi rảnh (idle) sẽ tiếp tục khi con trỏ chuột dừng lại.
      offset: Độ lệch mắt(%)
    force-idle-eye-animation:
      title: Chuyển động mắt nhàn rỗi (idle)
      description: Randomly look around when there is no active cursor focus.
    blink-enable:
      title: Mở chớp mắt
      description: Cho phép mô hình chớp mắt.
    auto-blink:
      title: Tự động
      description: Sử dụng hoạt ảnh chớp mắt mặc đinh cho mô hình
    force-auto-blink:
      title: Ép buộc
      description: Ép hoạt ảnh chớp mắt bằng bộ hẹn giờ ngoài
    blink-mode:
      title: Chế độ chớp mắt
      description: Chọn mô hình chớp mắc có sẵn hoặc bộ hẹn giờ chớp mắt bắt buộc của Aura.
    idle-motion:
      title: Hoạt ảnh nhàn rỗi
      no-motion: Không có hoạt ảnh khả dụng
      placeholder: Chọn hoạt ảnh
      disable-motion: Tắt
      disable-motion-description: Tắt hoạt ảnh nhàn rỗi
  parameters:
    title: Tham số mô hình
    render-scale:
      title: Tỉ lệ render
    fps:
      title: FPS
      description: Giới hạn tốc độ khung hình render
      options:
        unlimited: '∞'
    shadow: Đổ bóng
    reset-parameters: Đặt lại tham số mặc định
  clear-model-cache: Xóa bộ nhớ đệm của mô hình
  expressions:
    title: Biểu cảm
    override-toggle: Hệ thống biểu cảm
    sdk-preset-preserved-notice: >
      Quản lý biểu cảm SDK và nháy mắt được giữ nguyên khi tắt.
    no-expression: Không có biểu cảm khả dụng cho mô hình này.
    llm-integration-wip: Tích hợp công cụ LLM chưa được hoàn thiện.
    save-default: Lưu biểu cảm mặc định
    reset: Đặt lại tất cả biểu cảm
    expose-to-llm-toggle: Cho phép LLM truy cập
    expose-to-llm-options:
      none: Không
      all: Tất cả
      custom: Tùy chỉnh
microphone: Micro
models: Mô hình
pages:
  account:
    title: Tài khoản
    description: Xem hồ sơ của bạn và quản lý tài khoản
    notLoggedIn: Đăng nhập để xem tài khoản và truy cập tất cả tính năng
    login: Đăng nhập
    logout: Đăng xuất
    fluxBalance: Số dư Flux
    viewFluxDetails: Xem chi tiết
    signedInAs: Đăng nhập với
    profile:
      tab: Hồ sơ
      title: Hồ sơ
      description: Quản lý tên hiển thị công khai.
      name:
        label: Tên hiển thị
        placeholder: Cách người khác thấy bạn
      avatar:
        gravatarNotice: Ảnh đại diện từ Gravatar.
        gravatarLink: Quản lý trên gravatar.com
      action:
        save: Lưu thay đổi
      message:
        saved: Hồ sơ đã được cập nhật.
      error:
        fallback: Chúng tôi không thể lưu các thay đổi của bạn.
    connections:
      tab: Các tài khoản đã được liên kết
      title: Các tài khoản đã được liên kết
      description: Đăng nhập Aura thông qua các nhà cung cấp này. Hủy liên kết để thu hồi quyền truy cập, sau đó liên kết lại một lần nữa để chuyển sang tài khoản khác.
      status:
        linked: Đã liên kết
        notLinked: Chưa được liên kết
        linkedSince: Đã liên kết vào {date}
      action:
        link: Liên kết
        unlink: Hủy liên kết
      message:
        loading: Đang tải các tài khoản đã được liên kết...
        unlinked: '{provider} đã ngắt kết nối.'
        linked: '{provider} đã kết nối.'
        linkStarted: Đang chuyển hướng đến {provider}…
      error:
        listFailed: Không thể tải các tài khoản đã liên kết.
        unlinkFailed: Không thể hủy liên kết tài khoản này.
        linkFailed: Không thể khởi động liên kết luồng (link flow).
        accountAlreadyLinkedToDifferentUser: Tài khoản OAuth này đã được liên kết với một tài khoản Aura khác. Hãy chọn tài khoản nhà cung cấp khác hoặc hủy liên kết tài khoản đó khỏi tài khoản Aura kia trước.
        oauthCallbackFailed: Không thể kết nối tài khoản OAuth này. Hãy thử lại hoặc chọn tài khoản nhà cung cấp khác.
        lastAccount: Đây là phương thức đăng nhập duy nhất của bạn. Đặt mật khẩu trước khi hủy liên kết.
    security:
      tab: Bảo mật
      title: Bảo mật
      description: Thay đổi mật khẩu của bạn. Các thiết bị khác sẽ được đăng xuất.
      setDescription: Bạn đăng nhập thông qua nhà cung cấp tài khoản mạng xã hội, vì vậy hiện tại chưa có mật khẩu. Chúng tôi sẽ gửi email liên kết bảo mật để giúp bạn đặt mật khẩu.
      currentPassword:
        label: Mật khẩu hiện tại
        placeholder: Nhập mật khẩu hiện tại
      newPassword:
        label: Mật khẩu mới
        placeholder: Ít nhất 8 ký tự
      confirmPassword:
        label: Xác nhận mật khẩu mới
        placeholder: Lặp lại mật khẩu mới
      action:
        changePassword: Thay đổi mật khẩu
        sendSetLink: Gửi link thiết lập mật khẩu đến email của tôi
      message:
        changed: Mật khẩu đã được thay đổi. Các phiên khác đã được đăng xuất.
        setLinkSent: Kiểm tra {email} để thấy link đặt mật khẩu.
      error:
        fallback: Chúng tôi không thể thay đổi mật khẩu của bạn.
        setLinkFailed: Chúng tôi không thể gửi link thiết lập mật khẩu.
        passwordMismatch: Mật khẩu không khớp.
        passwordSameAsCurrent: Mật khẩu mới phải khác mật khẩu cũ.
    danger:
      tab: Vùng Nguy Hiểm
      title: Vùng Nguy Hiểm
      description: Các hành động không thể đảo ngược cho tài khoản ở đây.
      deleteAccount:
        title: Xóa tài khoản
        description: Xóa tài khoản và dữ liệu cá nhân vĩnh viễn.
        action: Xóa tài khoản
        modal:
          title: Xóa tài khoản?
          warning: Hành động này không thể đảo ngược. Các gói đăng ký đang hoạt đọng sẽ bị hủy, số dư Flux sẽ bị xóa sạch.
          confirmEmail:
            label: Nhập email để xác nhận
            placeholder: ''
            mismatch: Email không khớp.
          confirm: Gửi email xác nhận
          cancel: Hủy
        message:
          emailSent: Kiểm tra {email} để thấy link xóa.
        error:
          fallback: Không thể xóa. Hãy thử lại sau.
  card:
    activate: Kích hoạt
    active: Đang hoạt động
    active_badge: Hiện đang hoạt động
    activation_notice: Đã chuyển sang {name}. Cuộc trò chuyện hiện tại giờ sử dụng nhân vật này.
    cancel: Hủy thao tác
    save: Lưu thay đổi
    save_and_activate: Lưu và kích hoạt
    card_not_found: Không tìm thấy thẻ
    character: Nhân vật
    close: Đóng
    chat:
      provider: Trò chuyện / Nhà cung cấp
    consciousness:
      model: Ý thức / Mô hình
    vision:
      provider: Thị giác / Nhà cung cấp
      model: Thị giác / Mô hình
    created_by: được tạo bởi
    creator_notes: Ghi chú của tác giả
    delete: Xóa
    delete_card: Xóa thẻ
    delete_confirmation: Bạn có chắc muốn xóa thẻ này?
    description: Dùng preset thẻ nhân vật Aura
    description_label: Mô tả
    drop_here: Kéo vào đây để tải lên
    create_card: Tạo thẻ mới
    edit_card: Chỉnh sửa thẻ
    creation:
      identity: Danh tính
      name: Tên
      nickname: Biệt danh
      description: Mô tả
      behavior: Hành vi
      greetings: Lời chào (mỗi dòng một lời chào)
      settings: Cài đặt
      version: Phiên bản
      create: Tạo
      defaults:
        name: Tên
        personality: Bạn là một con người bình thường, tò mò về mọi thứ.
        scenario: Bạn vừa tỉnh dậy và quên hết quá khứ.
        systemprompt: Bạn sẽ nhận tin nhắn và trả lời như một con người thực sự.
        posthistoryinstructions: Nhớ bắt chước như một con người.
      modules_info: >-
        Cấu hình các module cho thẻ nhân vật này. Nếu không thiết lập, cấu hình mặc định sẽ được sử dụng.
      use_default: Sử dụng mặc định
      use_default_not_configured: Sử dụng mặc định (chưa cấu hình)
      fields_info:
        subtitle: >-
          Bạn có thể thêm chi tiết về nhân vật, giải thích lịch sử, bối cảnh và cách nhân vật nên trả lời.
        name: Tên chính thức của nhân vật.
        nickname: Có thể đặt biệt danh để ưu tiên dùng.
        description: Mô tả nhân vật này.
        notes: Thêm ghi chú cá nhân nếu muốn.
        personality: >-
          Miêu tả tính cách nhân vật. Nhút nhát? Tò mò? Hoặc khác?
        scenario: Hoàn cảnh xung quanh? Tình huống hiện tại?
        greetings_field: Lời chào
        greetings: Nhân vật nên chào như thế nào?
        systemprompt: Hướng dẫn AI LLM cách trả lời khi được hỏi.
        posthistoryinstructions: Đặt thông tin mà AI LLM nên đọc sau lịch sử hội thoại.
        version: >-
          Phiên bản thẻ, hãy tăng giá trị này nếu bạn đã chỉnh sửa thẻ từ trước.
        consciousness_model: Chọn mô hình ý thức (mô hình AI) cho nhân vật này.
        speech_model: Chọn mô hình tổng hợp tiếng nói và giọng đọc cho nhân vật này.
      errors:
        name: Tên không hợp lệ hoặc rỗng.
        version: 'Lỗi: Số phiên bản không hợp lệ!'
        description: 'Lỗi: Phải có mô tả cho thẻ này.'
        personality: 'Lỗi: Phải có tính cách cho nhân vật.'
        scenario: 'Lỗi: Phải có kịch bản.'
        systemprompt: 'Lỗi: Hãy cung cấp lời nhắc hệ thống'
        posthistoryinstructions: 'Lỗi: Cần có lịch sử đăng lời nhắc'
        invalid_artistry_json: 'Các tùy chọn cho nhà cung cấp nghệ thuật (Artistry provider) chứa JSON không hợp lệ.'
      none: Không
    modules: Mô-đun
    name_asc: Tên (A-Z)
    name_desc: Tên (Z-A)
    no_cards: Chưa có thẻ nào. Bấm nút trên để tải lên!
    no_results: Không tìm thấy thẻ phù hợp
    personality: Tính cách
    posthistoryinstructions: Hướng dẫn sau lịch sử
    recent: Thêm gần đây
    scenario: Kịch bản
    search: Tìm thẻ...
    sort_by: Sắp xếp theo
    body-model: Cơ Thể / Mô Hình Hiển Thị
    speech:
      provider: Giọng nói / Nhà cung cấp
      model: Giọng nói / Mô hình
      voice: Giọng nói / Giọng
    systemprompt: Lời nhắc hệ thống
    title: Thẻ Aura
    try_different_search: Hãy thử từ khóa khác
    export: Xuất
    exported: Card package exported
    export_failed: Failed to export card package
    imported: Card package imported
    import_missing_file: Card package is missing required files
    import_invalid_file: Card package file is invalid
    upload: Tải lên
    upload_desc: Click or drag an Aura card package to import
  memory:
    description: Nơi lưu trữ và tổ chức ký ức
    title: Bộ nhớ
  data:
    title: Dữ liệu
    description: Quản lý dữ liệu Aura đã lưu, xuất và đặt lại
    sections:
      chats:
        title: Phiên trò chuyện
        description: Xuất hoặc nhập đoạn trò chuyện đã lưu.
        export: Xuất hội thoại
        import: Nhập hội thoại
        delete: Xóa tất cả hội thoại
      models:
        title: Mô hình
        description: Remove imported Live2D, VRM, Spine, and MMD models.
        delete: Xóa tất cả mô hình
      modules:
        title: Các Mô-Đun
        description: Đặt lại tùy chọn mô-đun và thông tin xác thực.
        reset: Đặt lại cài đặt mô-đun
      providers:
        title: Nhà cung cấp
        description: Đã đặt lại toàn bộ thiết lập nhà cung cấp và thông tin xác thực.
        reset: Đặt lại cài đặt nhà cung cấp
      danger:
        title: Cảnh báo
        description: Các hành động không thể khôi phục. Hãy xuất những dữ liệu cần thiết trước khi tiếp tục.
      all:
        title: Xóa tất cả dữ liệu
        description: Xóa sạch toàn bộ thiết lập cục bộ, cấu hình nhà cung cấp và mô hình.
        delete: Xóa sạch dữ liệu
      desktop-folder:
        title: Mở thư mục dữ liệu ứng dụng
        description: Mở thư mục dữ liệu của Aura trong trình quản lý tệp tin của bạn.
        open: Mở thư mục
      desktop:
        title: Đặt lại thiết lập máy tính
        description: Xóa các cài đặt và trạng thái thực thi của Aura trên máy tính.
        center: Move desktop window to center
        reset: Đặt lại dữ liệu desktop
    confirmations:
      tooltip: Bạn chắc chứ?
      'yes': 'Đồng ý'
    status:
      exported: Đã xuất phiên trò chuyện.
      imported: Đã nhập phiên trò chuyện.
      import_error: Lỗi nhập dữ liệu. Vui lòng kiểm tra định dạng tệp.
      chats_deleted: Đã xóa các phiên trò chuyện.
      models_deleted: Đã xóa các mô hình.
      modules_reset: Đã đặt lại cài đặt mô-đun.
      providers_reset: Đã đặt lại cài đặt nhà cung cấp.
      all_deleted: Tất cả dữ liệu cục bộ đã bị xóa.
      desktop_window_centered: Desktop window moved to screen center.
      desktop_reset: Đã đặt lại dữ liệu ứng dụng máy tính.
  models:
    description: Live2D, VRM, Spine, MMD, etc.
    title: Mô hình
    sections:
      section:
        live2d:
          title: Live2D
          description: Cấu hình mô hình Live2D
        vrm:
          title: VRM
          description: Cấu hình mô hình 3D VRM
        scene: Bối cảnh
  modules:
    beat_sync:
      description: Rung cảm với nhịp điệu từ nguồn âm thanh
      title: Đồng bộ nhịp
      sections:
        audio_source:
          actions:
            start_screen_capture: Bắt đầu chụp màn hình
            stop: Dừng
          description: Chọn nguồn âm thanh để nhận diện nhịp điệu.
          title: Nguồn âm thanh
        beat_visualizer:
          title: Trình trực quan hóa nhịp
        parameters:
          advanced_parameters: Thông số nâng cao
          description: Tinh chỉnh các thông số nhận diện nhịp điệu.
          title: Thông số
          parameters:
            adaptive_threshold:
              description: >-
                Áp dụng ngưỡng thích ứng dựa trên sự biến thiên tín hiệu theo thời gian.
              label: Ngưỡng thích ứng
            buffer_duration:
              description: Thời gian của bộ đệm phân tích nội bộ.
              label: Thời lượng bộ đệm
            envelope_filter_frequency:
              description: >-
                Tần số cho bộ lọc bao bì (envelope filter) để làm mượt các thay đổi năng lượng.
              label: Tần số lọc bao bì
            highpass_filter_frequency:
              description: >-
                Tần số cho bộ lọc thông cao giúp giảm tần số thấp như tiếng ồn trầm.
              label: Tần số lọc thông cao
            lowpass_filter_frequency:
              description: >-
                Tần số cho bộ lọc thông thấp giúp giảm tần số cao như giọng hát.
              label: Tần số lọc thông thấp
            min_beat_interval:
              description: BPM tối đa hoặc khoảng thời gian tối thiểu giữa các nhịp được phát hiện.
              label: BPM tối đa / Khoảng nhịp tối thiểu
            sensitivity:
              label: Độ nhạy
            spectral_flux:
              description: Bật phát hiện dựa trên thông lượng phổ (spectral flux).
              label: Thông lượng phổ
            warmup:
              description: Làm nóng trước khi nhận diện để đạt độ chính xác cao hơn.
              label: Khởi động (Warmup)
    artistry:
      title: Nghệ thuật
      description: Tạo ảnh, cảnh nền và tranh ảnh.
      page:
        title: Cấu Hình Nhà Cung Cấp Nghệ Thuật
        description: Chọn nhà cung cấp backend đang hoạt động cho việc tạo ảnh. Các nhân vật có thể ghi đè trong cài đặt Thẻ của họ.
      providers:
        none:
          name: Không
          description: Bỏ qua và vô hiệu hóa module tạo ảnh trong phạm vi toàn cục.
        comfyui:
          name: ComfyUI (Cục bộ)
          description: Sử dụng bản ComfyUI cục bộ thông qua WSL cho việc tạo ảnh.
        replicate:
          name: Replicate.ai (Cloud)
          description: Sử dụng các mô hình dựa trên đám mây thông qua API của Replicate.
        nanobanana:
          name: Nano Banana (Preview)
          description: Sử dụng Google AI Studio để xem trước ảnh và các phản ứng.
      card:
        description: Cấu hình cách Aura tạo ảnh và các nội dung đồ họa.
        comfyui_empty: ComfyUI workflows chưa được cấu hình. Đi tới Cài đặt → Nhà cung cấp → ComfyUI để tải mẫu workflow.
        exposed_fields: '{count} trường được cung cấp'
        open_on_replicate: Mở bằng Replicate
        instruction_sync:
          title: ComfyUI Instruction Sync
          description: Prompt được chỉ định đã sẵn sàng cho workflow {workflowName} của bạn. Việc áp dụng sẽ ghi đè hướng dẫn tiện ích hiện tại nên AI sẽ biết cách dùng mẫu cụ thể này.
          apply: Áp Dụng Prompt Được Khuyến Nghị
          keep: Keep Existing
      provider: Nhà Cung Cấp Nghệ Thuật
      spawn_mode:
        label: Manifestation Mode (Spawn Mode)
        description: Chọn cách ảnh được đưa vào giao diện.
        options:
          bg: Nền Môi Trường
          inline: Inline Chat
          widget: Overlay Widget
          bg_widget: Kép (Ảnh Nền + Tiện Ích)
      autonomous:
        title: Cinematic Autonomy (Autonomous Artist)
        description: When enabled, the "Producer" runs in parallel to the character to decide if a visual is needed. This prevents the character from forgetting to manifest scenes.
        threshold: Manifestation Threshold
        threshold_description: Use {min} for aggressive scene creation or {max} to require stronger evidence before generating.
        threshold_min: Luôn Luôn Tạo (0%)
        threshold_max: Khắt Khe (100%)
      model:
        label: Mô Hình Nghệ Thuật (Ghi Đè Tùy Chọn)
        description: Model identifier if needed by provider
      prompt-prefix:
        label: Tiền Tố Prompt Nghệ Thuật Mặc Định
        description: Được thêm vào đầu mỗi prompt khi gửi đến trình tạo ảnh.
      options:
        label: Tùy Chọn Nhà Cung Cấp Nghệ Thuật (JSON)
      widget-instructions:
        label: Prompt Tiện Ích Hệ Thống
        description: Tùy chỉnh các hướng dẫn cho AI về cách dùng các khả năng tạo nội dung.
    categories:
      essential: Cần thiết
      messaging: Messaging
      gaming: Gaming
      artistry: Artistry
    consciousness:
      description: Tính cách, mô hình mong muốn, v.v.
      sections:
        section:
          provider-model-selection:
            collapse: Thu gọn
            custom_model_placeholder: Nhập tên mô hình tùy chỉnh...
            current_model_label: 'Mô hình hiện tại:'
            description: Chọn nhà cung cấp LLM phù hợp cho ý thức
            error: Lỗi tải mô hình
            health_check_failed: Kiểm tra trạng thái thất bại
            no_providers_configured_title: Chưa cấu hình nhà cung cấp
            no_providers_configured_description: Bấm vào đây để thiết lập nhà cung cấp LLM
            expand: Mở rộng
            loading: Đang tải mô hình...
            manual_model_name: Tên mô hình
            manual_model_placeholder: Nhập tên mô hình dùng với nhà cung cấp này
            no_models: Không có mô hình
            no_models_description: Không tìm thấy mô hình nào cho nhà cung cấp này
            no_search_results: Không có kết quả phù hợp
            no_search_results_description: Không có mô hình nào khớp với '{query}'. Thử từ khóa khác.
            not_supported: Không hỗ trợ liệt kê mô hình
            not_supported_description: Nhà cung cấp này không hỗ trợ chức năng liệt kê mô hình
            search_placeholder: Tìm mô hình...
            search_results: Tìm thấy {count}/{total} mô hình
            show_less: Ẩn bớt
            show_more: Hiện thêm
            subtitle: Chọn một mô hình mặc định từ nhà cung cấp
            title: Mô hình
      title: Ý thức
    description: Tư duy, thị giác, tổng hợp giọng nói, chơi game, v.v.
    gaming-factorio:
      description: Chơi Factorio!
      title: Factorio
      enable: Bật tích hợp Factorio
      enable-description: Cho phép Aura tương tác với trò chơi Factorio
      server-address: Địa chỉ máy chủ
      server-address-description: Địa chỉ IP hoặc tên máy chủ của máy chủ Factorio
      server-address-placeholder: Nhập địa chỉ máy chủ (ví dụ localhost hoặc 192.168.1.100)
      server-port: Cổng máy chủ
      server-port-description: Số cổng của máy chủ Factorio (mặc định 34197)
      username: Tên người dùng
      username-description: Tên người dùng của bạn trên máy chủ Factorio
      username-placeholder: Nhập tên người dùng Factorio của bạn
      configured: Đã cấu hình Factorio thành công!
    gaming-minecraft:
      description: Chơi Minecraft!
      title: Minecraft
      enable: Bật tích hợp Minecraft
      enable-description: >-
        Include Minecraft self-knowledge in Stage chat turns and keep passive runtime visibility enabled.
      configured: Đã cấu hình Minecraft thành công!
      read-only:
        title: Read-only shell
        description: >-
          Stage currently exposes Minecraft as a passive shell. Runtime status and traffic are visible here, but service configuration stays in the Minecraft service files.
      setup:
        title: Thiết lập
        description: >-
          Bạn có thể tìm thấy các chỉ dẫn cho việc thiết lập bot trong file sau
      runtime:
        title: Observed runtime
        connection: Kết nối
        latest-context: Bối cảnh bot mới nhất
        waiting: Waiting for a fresh bot-originated context push.
        unknown: Không xác định
      debug:
        title: Minecraft traffic
        empty: No Minecraft traffic observed yet.
        source: 'Nguồn: {source}'
      status:
        service-online: Dịch vụ trực tuyến
        service-offline: Dịch vụ ngoại tuyến
        no-runtime-context: No bot context observed yet
        last-context-seconds: 'Last bot context: {seconds}s ago'
        last-context-stale: 'Last bot context: Stale'
    hearing:
      description: Cấu hình nhận diện giọng nói
      title: Nghe
      sections:
        section:
          provider-selection:
            description: Chọn nhà cung cấp nhận diện giọng nói phù hợp
          confidence-threshold:
            title: Ngưỡng Tự Tin
            description: >-
              Lọc các đoạn nhận dạng giọng nói có độ tin cậy thấp để giảm tình trạng ảo tưởng của Whisper. Giá trị càng tiến về 0 thì càng khắt khe bơn; kéo sang trái để vô hiệu. Chỉ hiệu quả với các nhà dung cấp API của Whisper (ví dụ như OpenAI, Groq).
            disabled: Tắt
            verbose-json-note: >-
              Note: Nếu nhà cung cấp của bạn không hỗ trợ phản hồi verbose_json, cài đặng này sẽ không có tác dụng.
            verbose-json-unsupported: >-
              Nhà cung cấp của bạn không trả về các đoạn (segment) verbose_json. Lọc kết quả dựa trên độ tin cậy không có tác dụng cho đoạn phiên âm mới nhất.
    memory-long-term:
      description: Cài đặt và quản lý trí nhớ dài hạn
      title: Trí nhớ dài hạn
    memory-short-term:
      description: Cài đặt và quản lý trí nhớ ngắn hạn
      title: Trí nhớ ngắn hạn
    messaging-discord:
      description: Trò chuyện & gọi thoại qua Discord
      title: Discord
      enable: Bật tích hợp Discord
      enable-description: Cho phép Aura tương tác qua Discord
      token: Mã token của bot
      token-description: Mã token bot Discord của bạn
      token-placeholder: Nhập mã token bot Discord của bạn
      configured: Đã cấu hình Discord thành công!
    speech:
      description: Tổng hợp giọng nói
      sections:
        section:
          playground:
            buttons:
              stop:
                label: Dừng
            select-voice:
              loading: Đang tải mô hình...
              required: Vui lòng chọn một giọng nói
          voice-pack:
            description: Chọn một giọng nói được tuyển chọn cho nhân vật đang hoạt động
            empty: Không có Gói Giọng Nói khả dụng nào
            error: Lỗi khi tải Gói Giọng Nói
            loading: Đang tải Gói Giọng Nói...
            title: Gói Giọng Nói
          provider-voice-selection:
            custom_model_placeholder: Nhập tên mô hình tùy chỉnh...
            custom_voice_placeholder: Nhập ID giọng nói tùy chỉnh...
            description: Chọn nhà cung cấp giọng nói phù hợp
            no_models: Không có mô hình
            no_models_description: Không tìm thấy mô hình nào cho nhà cung cấp này
            no_voices: Không có giọng nói
            no_voices_description: Không tìm thấy giọng nói nào cho nhà cung cấp này
            no_voices_hint: Bạn có thể nhập tên giọng nói tùy chỉnh bên dưới.
            pause: Tạm dừng
            play_sample: Nghe thử
            search_models_placeholder: Tìm mô hình...
            search_models_results: Tìm thấy {count}/{total} mô hình
            search_voices_placeholder: Tìm giọng nói...
            search_voices_results: Tìm thấy {count}/{total} giọng nói
            unsupported_voice_warning_title: Không có giọng nói được hỗ trợ
            unsupported_voice_warning_content: >-
              Hãy thử nhà cung cấp hoặc mô hình khác. Chúng tôi đang nỗ lực cập nhật thêm giọng nói sớm nhất có thể. Nếu cần gấp, hãy báo cho chúng tôi trên GitHub.
            show_less: Ẩn bớt
            show_more: Hiện thêm
            title: Nhà cung cấp
          voice-settings:
            input-ssml:
              placeholder: Nhập văn bản SSML...
            use-ssml:
              description: Bật để nhập SSML thô thay vì văn bản
              label: Dùng SSML tùy chỉnh
      title: Giọng nói
    title: Module
    vision:
      description: Thị giác
      title: Thị giác
    x:
      description: Sử Dụng Twitter
      title: X / Twitter
      enable: Bật tích hợp X / Twitter
      enable-description: Cho phép Aura tương tác với X / Twitter
      api-key: Khóa API
      api-key-description: Khóa API X / Twitter của bạn
      api-key-placeholder: Nhập khóa API X / Twitter của bạn
      api-secret: Bí mật API
      api-secret-description: Bí mật API X / Twitter của bạn
      api-secret-placeholder: Nhập bí mật API X / Twitter của bạn
      access-token: Mã truy cập
      access-token-description: Mã truy cập X / Twitter của bạn
      access-token-placeholder: Nhập mã truy cập X / Twitter của bạn
      access-token-secret: Bí mật mã truy cập
      access-token-secret-description: Bí mật mã truy cập X / Twitter của bạn
      access-token-secret-placeholder: Nhập bí mật mã truy cập X / Twitter của bạn
      configured: Đã cấu hình X / Twitter thành công!
    web-search:
      title: Web Search
      description: Let Aura search the web for current information
      enable: Enable Web Search
      enable-description: Allow Aura to search the web during chat
      api-key: Tavily API Key
      api-key-description: Web search is powered by Tavily. Get a free API key at tavily.com.
      api-key-placeholder: Enter your Tavily API key
      configured: Web search is ready to use!
    mcp-server:
      title: Các máy chủ MCP
      description: Configure MCP servers and bring their tools into Aura.
      config-path: Config file
      runtime-title: Trạng thái thực thi
      empty: No MCP servers yet — click "Add server" below to create one, or paste a config via "Edit JSON".
      error-title: Úi
      success-title: Xong!
      existing:
        title: Configured
        description: Servers recorded in mcp.json. Click any row to expand and edit it.
        empty: Chưa có cái nào ở đây hết. Thêm một cái vào bên dưới đi!
      add:
        title: Mới
        description: "Fill in a new server, then click \"Save and restart\" — it'll move into \"Configured\" above."
        pending-badge: Chưa được lưu
      status:
        unknown: chưa tải
      actions:
        open-config: Reveal in file manager
        apply-and-restart: Lưu và khởi động lại
        restart: Khởi động lại MCP
        add-server: Thêm máy chủ
        add-env: Thêm biến
        remove: Xóa
        test: Test
        edit-json: Chỉnh sửa JSON
        close-json: Đóng
        format-json: Định dạng
        reset-draft: Khởi động lại
        apply-json: Áp dụng
        cancel: Hủy
        expand: Mở rộng
        collapse: Collapse
      fields:
        identifier:
          label: Identifier
          description: Tên độc nhất; trở thành khóa trong mcp.json.
          placeholder: 'ví dụ: filesystem'
        command:
          label: Lệnh
          description: Executable spawned over stdio.
          placeholder: 'ví dụ: npx'
        args:
          label: Đối số
          description: Mỗi dòng một đối số, theo thứ tự.
          placeholder: "-y\nsome-package-name\n/tmp"
        cwd:
          label: Thư mục làm việc
          description: Optional directory used as the process working directory.
          placeholder: e.g. /Users/you/project
        env:
          label: Môi trường
          description: Các biến được đưa vào tiến trình con.
          key-placeholder: KEY
          value-placeholder: giá trị
        enabled:
          label: Bật
      json:
        title: Chỉnh sửa mcp.json
        description: 'Edit the raw JSON directly. Click "Apply" to load it into the form, then "Save and restart" to write it to disk.'
        placeholder: Dán mcp.json vào đây…
      test:
        title: Kiểm tra kết nối
        description: We'll spawn the server briefly to check the command works and see what tools it exposes.
        pick-server-label: Máy chủ
        no-servers: Chưa có gì để kiểm tra
        no-server-selected: Chọn một máy chủ trước.
        server-disabled: '"{name}" is disabled — enable it on the card first.'
        disabled-suffix: vô hiệu hóa
        untitled: untitled
        running: Đang kiểm tra…
        success: Kết nối thành công! Đã tìm thấy {count} công cụ trong {ms}ms.
        failure: Kết nối thất bại sau {ms}ms
      errors:
        empty-identifier: Server # {index} is missing an identifier.
        duplicate-identifier: Identifier "{name}" is used more than once — names need to be unique.
        empty-command: '"{name}" đang thiếu một lệnh.'
        invalid-shape: Nhìn không giống mcp.json hợp lệ — root cần một trường "mcpServers".
      messages:
        opened: Đã mở {path} trong trình quản lý tệp của bạn
        json-applied: JSON applied to the form. Click "Save and restart" to persist it to disk.
        restarted: Tất cả đã được khởi động lại! {started} đã khởi động, {failed} thất bại, {skipped} đã bỏ qua.
  flux:
    title: Flux
    buy: Mua
    currency: Tiền tệ
    description: Số Flux hiện tại
    packagesError: Failed to load packages. Please try again later.
    checkout:
      success: Thanh toán hoàn tất! Flux của bạn đã được nạp.
      canceled: Thanh toán đã bị hủy.
      error: Đã xảy ra sự cố. Xin vui lòng thử lại sau.
    audit:
      title: Lịch Sử Giao Dịch
      time: Thời gian
      type: Loại
      detail: Chi tiết
      amount: Số lượng
      typeAddition: Nạp thêm
      typeConsumption: Mức sử dụng
      typeInitial: Khoản Cấp Ban Đầu
      typePromo: Promo Grant
      loading: Đang tải lịch sử...
      empty: Chưa có giao dịch nào.
      loadMore: Tải Thêm
      delayHint: Các bản ghi về mức sử dụng có thể bị trễ 1 phút
      ttsRequests: các yêu cầu
    packages:
      title: Gói Flux
      buy: Mua
      description: Flux packages to choose from.
  providers:
    catalog:
      edit:
        config-id-not-found: Không tìm thấy cấu hình nhà cung cấp.
        definition-id-not-found: Không tìm thấy định nghĩa nhà cung cấp.
        actions:
          more-options: Thêm tùy chọn
          delete: Xóa
        validation:
          failed:
            title: Xác thực không thành công. Vui lòng kiểm tra lại cài đặt.
            description: >-
              Bạn vẫn có thể lưu cấu hình nếu muốn tiếp tục.
            action: Vẫn lưu
        config:
          common:
            fields:
              field:
                api-key:
                  label: Khóa API
                  description: Khóa dùng để ủy quyền yêu cầu cho nhà cung cấp này
                  placeholder: sk-...
                base-url:
                  label: URL cơ sở
                  description: >-
                    Địa chỉ kết nối dịch vụ. Thường là http://localhost:11434/v1 hoặc tương tự.
                  placeholder: URL cơ sở...
                headers:
                  label: Tiêu đề HTTP tùy chỉnh
                  description: Tùy chỉnh HTTP Headers
                  key:
                    placeholder: Khóa (Key)
                  value:
                    placeholder: Giá trị (Value)
                thinking-mode:
                  label: Chế độ suy nghĩ
                  description: >
                    Kiểm soát hành vi suy nghĩ của Ollama/GPT-OSS.
                  options:
                    auto: Tự động
                    disable: Tắt
                    enable: Bật
                    low: Thấp
                    medium: Trung bình
                    high: Cao
        validators:
          actions:
            validate: Xác thực
          empty: Không có bước xác thực khả dụng.
          openai-compatible:
            check-config:
              title: Cấu hình
            check-connectivity:
              title: Kết nối
            check-supports-model-listing:
              title: Liệt kê mô hình
            check-supports-chat-completion:
              title: Hoàn tất hội thoại
          status:
            validating: Đang xác thực...
            valid: Thành công
            invalid: Lỗi
          title: Kiểm tra
        providers:
          provider:
            ollama:
              troubleshooting:
                validators:
                  openai-compatible-check-connectivity:
                    label: Cần cấu hình thêm cho Ollama
                    content: >-
                      Kiểm tra kết nối thất bại. Đối với Ollama, bạn cần đặt biến môi trường <code>OLLAMA_HOST</code> khi khởi động để cho phép kết nối. Xem hướng dẫn tại trang tài liệu.
    common:
      continueAnyway: Vẫn tiếp tục
      goToModelSelection: Chọn Mô hình →
      fields:
        field:
          api-key:
            label: Nhập khóa API
      section:
        advanced:
          fields:
            field:
              headers:
                description: Thêm HTTP header tùy chỉnh
                key:
                  placeholder: Khóa
                label: HTTP Headers
                value:
                  placeholder: Giá trị
          title: Nâng cao
        basic:
          description: Cài đặt cơ bản
          title: Cơ bản
        voice:
          title: Cài đặt giọng nói
    labels:
      recommended: Được gợi ý
    filters:
      pricing: Bảng Giá
      deployment: Deployment
      all: Tất cả
      free: Miễn phí
      paid: Trả phí
      internal: Internal
      local: Cục bộ
      cloud: Đám mây
    categories:
      chat:
        title: Chat
        description: 'Nhà cung cấp mô hình tạo văn bản. Ví dụ: OpenRouter, OpenAI, Ollama.'
      vision:
        title: Vision
        description: Các nhà cung cấp mô hình thị giác máy cho việc hiểu hình ảnh.
      speech:
        title: Giọng nói
        description: 'Các nhà cung cấp mô hình giọng nói (text-to-speech). Ví dụ: ElevenLabs, Azure Speech.'
      transcription:
        title: Phiên âm
        description: >-
          Các nhà cung cấp mô hình phiên âm (speech-to-text). Ví dụ: Whisper.cpp OpenAI, Azure Speech
      artistry:
        title: Nghệ thuật
        description: 'Các nhà cung cấp mô hình tạo ảnh và thiết kế. Ví dụ: ComfyUI, Replicate.'
        items:
          comfyui:
            description: Chương trình tạo ảnh cục bộ.
          replicate:
            description: Dịch vụ mô hình suy luận dựa trên đám mây.
          nanobanana:
            description: Google AI Studio Image Preview.
    helpinfo:
      title: Lần đầu tới đây?
      description: >
        {chat} Aura cần ít nhất một nhà cung cấp để suy nghĩ và hoạt động đúng cách. Có thể coi nó như bộ não của nhân vật Aura trong hệ thống.
    explained:
      chat: 'Nhà cung cấp mô hình tạo văn bản. Ví dụ: OpenRouter, OpenAI, Ollama.'
      Speech: 'Nhà cung cấp mô hình giọng nói (text-to-speech). Ví dụ: ElevenLabs, Azure Speech.'
      Transcription: >-
        Nhà cung cấp mô hình chuyển giọng nói thành văn bản. Ví dụ: Whisper.cpp, OpenAI, Azure Speech
    description: LLMs, nhà cung cấp giọng nói, v.v.
    provider:
      app-local-audio-transcription:
        title: Ứng dụng (Local)
        description: Runs on-device, no API key needed
      app-local-audio-speech:
        title: Ứng dụng (Local)
        description: Runs on-device, no API key needed
      browser-local-audio-transcription:
        title: Trình duyệt (Local)
        description: Runs on-device, no API key needed
      browser-local-audio-speech:
        title: Trình duyệt (Local)
        description: Runs on-device, no API key needed
      alibaba-cloud-model-studio:
        description: bailian.console.aliyun.com
        title: Mô hình Studio Alibaba Cloud
      amazon-bedrock:
        title: Amazon Bedrock
        description: aws.amazon.com/bedrock
        config:
          api-key:
            label: Bedrock API Key
            description: Amazon Bedrock API key (generate in AWS Console → Bedrock → API Keys)
            placeholder: bedrock-...
          region:
            label: AWS Region
            description: AWS region where Bedrock is enabled (e.g. us-east-1, us-west-2)
      anthropic:
        description: anthropic.com
        title: Anthropic | Claude
        helpinfo:
          title: Trước khi bắt đầu
          description:
            part1: >-
              Anthropic gần đây công bố hỗ trợ beta cho SDK OpenAI
            part2: (xem thêm tại đây)
            part3: nhưng do chi tiết triển khai đi kèm
            part4: >-
              với hạn chế không tương thích hoàn toàn với SDK OpenAI, hiện chưa thể dùng nhà cung cấp này trong trình duyệt.
            part5: >-
              Nếu cần dùng, bạn phải có proxy backend riêng như Serverless Function
            part6: hoặc dịch vụ bypass CORS để vượt hạn chế.
      cloudflare-workers-ai:
        description: cloudflare.com
        fields:
          field:
            account-id:
              description: ID tài khoản Cloudflare
              label: ID Tài khoản
              placeholder: ID tài khoản Cloudflare của bạn
            api-key:
              placeholder: Nhập khóa API cho Cloudflare
        title: Cloudflare Workers AI
      common:
        status:
          validating: Đang xác thực
          valid: Cấu hình có vẻ hợp lệ.
        fields:
          field:
            pitch:
              description: Điều chỉnh cao độ giọng nói
              label: Cao độ
            speed:
              description: Điều chỉnh tốc độ giọng nói
              label: Tốc độ
            volume:
              description: Điều chỉnh âm lượng
              label: Âm lượng
      deepgram-tts:
        description: deepgram.com
        title: Deepgram
      speech-noop:
        title: Không có
        description: Không phát âm thanh.
      comfyui:
        settings:
          title: ComfyUI (Local)
          heading: ComfyUI Native API
          description: Connect to your local ComfyUI and bring your own workflows.
          info:
            what_you_need:
              label: Những Gì Bạn Cần
              value: ComfyUI running locally or on your network.
            how_to_export:
              label: Cách Để Xuất
              value: Bật Chế Độ Nhà Phát Triển → "Lưu (Định Dạng API)".
            scope_boundary:
              label: Giới Hạn Phạm Vi
              value: Model downloads & node installs are your job.
          connection:
            title: Kết nối
            connected: Đã kết nối
            failed: Kết nối thất bại
            error_prefix: Lỗi
            test: Test
            testing: Testing...
            unknown_error: Lỗi kết nối không xác định
            unknown_gpu: GPU không xác định
            server_url:
              label: Server URL
              description: Địa chỉ ComfyUI đang hoạt động
              placeholder: http://localhost:8188
          cors:
            title: Yêu Cầu Bị Chặn Bởi CORS
            description: ComfyUI mặc định chặn các yêu cầu từ các ứng dụng khác. Để cho phép Aura kết nối, bạn phải bắt đầu ComfyUI với flag `--enable-cors-header "*"`.
            command: python main.py --enable-cors-header "*"
          workflows:
            title: Mẫu Workflow
            upload: Tải Workflow
            cancel_upload: Hủy
            empty: No workflows uploaded yet. Click "Upload Workflow" to import a workflow_api.json from ComfyUI.
            exposed_parameters: Exposed Parameters
            summary: '{nodes} nodes · {fields} exposed fields'
            remove: Remove
            config_snippet: Artistry Config Snippet
            copy_json: Copy JSON
            paste_hint: Paste this into your Aura Card artistry config to override these nodes.
          upload:
            prompt: Drop or select a workflow_api.json file
            invalid_json: Invalid JSON
            workflow_name:
              label: Tên Workflow
              description: Cho workflow này một cái tên dễ nhận biết nào
              placeholder: e.g. Anime Text2Img
            select_fields: 'Select fields to expose to the AI agent:'
            fields_exposed: '{count} trường được cung cấp'
            save: Lưu Workflow
      replicate:
        settings:
          title: Replicate.ai
          heading: Cấu Hình Replicate.ai
          description: Cấu hình cài đặt trình tạo ảnh của bạn.
          api_key:
            label: Khóa API
            description: Token Replicate API của bạn (bắt đầu với r8_)
            placeholder: r8_XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
          default_model:
            label: Mô Hình Mặc Định
            description: Fallback owner/model string to use if the character card doesn't specify one
            placeholder: black-forest-labs/flux-schnell
          aspect_ratio:
            label: Tỉ Lệ Khung Hình
            description: 'Tỉ lệ ảnh mặc định (ví dụ: 16:9 1:1 9:16)'
            placeholder: '16:9'
          inference_steps:
            label: Các Bước Suy Luận
            description: Số lượng bước cho quá trình khử nhiễu (giá trị thấp thì nhanh hơn, giá trị cao thì chất lượng tốt hơn)
      nanobanana:
        settings:
          title: Nano Banana
          heading: Nano Banana (Google AI Studio)
          description: Configure Google Gemini's native image generation capabilities.
          api_key:
            label: API Key
            description: Khóa Google AI Studio API của bạn
            placeholder: AIpk...
          preferred_model:
            label: Preferred Model
            description: The specific Gemini image preview model to use
          default_resolution:
            label: Độ Phân Giải Mặc Định
            description: Độ phân giải mong muốn cho ảnh được tạo
          model_options:
            nano_banana_2: Nano Banana 2 (Gemini 3.1 Flash Image)
            nano_banana_pro: Nano Banana Pro (Gemini 3 Pro Image)
            nano_banana: Nano Banana (Gemini 2.5 Flash Image)
      deepseek:
        description: deepseek.com
        title: DeepSeek
      elevenlabs:
        description: elevenlabs.io
        fields:
          field:
            simularity-boost:
              description: Bám sát giọng gốc
              label: Tăng độ tương đồng
            speaker-boost:
              description: Giọng nói tự nhiên hơn
              label: Tăng độ chân thực
            speed:
              description: Tốc độ giọng nói
              label: Tốc độ
            stability:
              description: Độ ổn định và ngẫu nhiên
              label: Ổn định
            style:
              description: Cường điệu phong cách giọng
              label: Phong cách
        playground:
          buttons:
            button:
              test-voice:
                generating: Đang tạo...
                label: Thử giọng
          fields:
            field:
              input:
                placeholder: Nhập văn bản để thử giọng...
              language:
                description: Chọn ngôn ngữ
                label: Ngôn ngữ
              voice:
                description: Chọn giọng nói ưa thích
                label: Giọng
          title: Thử nghiệm giọng nói
          validation:
            error-missing-api-key: Vui lòng nhập khóa API để thử giọng.
        title: ElevenLabs
      kokoro-local:
        description: Chuyển văn bản thành giọng nói cục bộ dùng Kokoro-82M.
        fields:
          field:
            model:
              label: Chọn mô hình
              description: Mô hình nhỏ tải nhanh hơn nhưng chất lượng thấp hơn chút.
        models:
          fp32-webgpu:
            description: >-
              Mô hình độ chính xác cao dùng WebGPU - Khuyên dùng cho thiết bị hỗ trợ
          fp32:
            description: Độ chính xác đầy đủ (Full precision)
          fp16:
            description: Độ chính xác một nửa (Half precision)
          q8:
            description: Lượng tử hóa 8-bit
          q4:
            description: Lượng tử hóa 4-bit
          q4f16:
            description: 4-bit với FP16
        playground:
          default-text: Xin chào! Đây là bản thử nghiệm hệ thống giọng nói Kokoro.
          title: Thử nghiệm giọng nói
        title: Kokoro TTS (Cục bộ)
      fireworks:
        description: fireworks.ai
        title: Fireworks.ai
      google-gemini-audio-speech:
        description: aistudio.google.com
        title: Google Gemini
      microsoft-speech:
        description: speech.microsoft.com
        fields:
          field:
            region:
              description: Khu vực dịch vụ Speech
              label: Khu vực
        title: Microsoft / Azure Speech
      index-tts-vllm:
        description: https://index-tts.github.io/
        title: Bilibili / IndexTTS
        callout_indextts2_unavailable_title: Hỗ trợ hạn chế
        callout_indextts2_unavailable: IndexTTS2 hiện chưa hỗ trợ. Vui lòng dùng IndexTTS.
      azure-ai-foundry:
        description: Azure AI Foundry
        title: Azure AI Foundry
      minimax:
        description: minimaxi.com
        title: MiniMax
      minimax-global:
        description: minimax.io
        title: MiniMax Global
      minimax-speech:
        description: minimax.io
        title: MiniMax Speech
      mimo:
        description: api.xiaomimimo.com
        title: Xiaomi MiMo
      mistral:
        description: mistral.ai
        title: Mistral
      moonshot:
        description: moonshot.ai
        title: Moonshot AI
      modelscope:
        description: modelscope.cn
        title: ModelScope
      novita:
        description: novita.ai
        title: Novita
      ollama:
        description: ollama.ai
        title: Ollama
      openai:
        description: openai.com
        title: OpenAI
      azure-openai:
        description: Azure OpenAI API
        title: Azure OpenAI
      openai-compatible:
        description: Tương thích OpenAI
        title: Tương thích OpenAI
      nvidia:
        description: build.nvidia.com
        title: NVIDIA NIM
      n1n:
        description: n1n.ai - Cung cấp API AI hiệu năng cao.
        title: n1n
      openpaths:
        description: openpaths.io
        title: OpenPaths
      openrouter:
        description: openrouter.ai
        title: OpenRouter
      openrouter-audio-speech:
        description: openrouter.ai
        title: OpenRouter
      perplexity:
        description: perplexity.ai
        title: Perplexity
      player2:
        description: player2.game
        title: Player2
      together:
        description: together.ai
        title: Together.ai
      google-generative-ai:
        description: gemini.google.com
        title: Google Gemini
      groq:
        description: groq.com
        title: Groq
      featherless:
        description: featherless.ai
        title: Featherless AI
      lm-studio:
        description: lmstudio.ai
        title: LM Studio
      vllm:
        description: vllm.ai
        title: vLLM
      volcengine:
        description: volcengine.com
        fields:
          field:
            appId:
              description: App ID của dự án (lấy trong Console)
              label: App ID
        title: Volcano Engine
      volcengine-coding-plan:
        description: Volcengine Coding Plan
        title: Volcengine Coding Plan
      byteplus:
        description: byteplus.com
        title: BytePlus
      byteplus-coding-plan:
        description: BytePlus Coding Plan
        title: BytePlus Coding Plan
      xai:
        description: x.ai
        title: xAI
      zai:
        description: z.ai
        title: Z.ai
      302-ai:
        description: 302.AI
        title: 302.AI
      comet-api:
        description: CometAPI.com
        title: Comet API
      cerebras:
        description: cerebras.ai
        title: Cerebras
      aliyun-nls:
        description: Aliyun NLS
        title: Aliyun NLS
      browser-web-speech-api:
        description: STT gốc trình duyệt (yêu cầu Chrome/Edge/Safari)
        title: Web Speech API
      official:
        title: Nhà Cung Cấp Chính Thức
        description: Nhà cung cấp AI chính thức bởi Aura.
        speech-title: Official Speech Provider
        speech-description: Official text-to-speech provider by Aura.
        speech-streaming-title: Nhà Cung Cấp Giọng Nói Thời Gian Thực (Streaming) Chính Thức
        speech-streaming-description: Nhà cung cấp text-to-speech độ trễ thấp chính thức bởi Aura (WebSocket hai chiều).
        transcription-title: Nhà Cung Cấp Phiên Âm Chính Thức
        transcription-description: Nhà cung cấp speech-to-text chính thức bởi Aura.
      transcriptions:
        playground:
          title: Thử nghiệm chuyển văn bản
      aihubmix:
        title: AIHubMix
        description: https://aihubmix.com (Giảm giá 10%)
    title: Nhà cung cấp
  connection:
    description: Cấu hình kết nối máy chủ WebSocket
    title: Kết nối
    websocket-url:
      description: Địa chỉ đầy đủ máy chủ WebSocket (ví dụ ws://localhost:6121/ws)
      label: Địa chỉ máy chủ WebSocket
      placeholder: ws://localhost:6121/ws
    server-hostname:
      label: Expose On Network
      description: >-
        Choose whether the Aura gateway only listens on this device or can be reached from your local network.
      advanced-label: Bind Hostname
      advanced-description: >-
        Use a specific hostname or IP address when you need manual network binding.
      options:
        this-device: This device
        all: All
        advanced: Advanced
    server-auth-token:
      label: Auth Token
      description: >-
        Security token required by remote clients that connect to this gateway. When left empty, Aura generates a new token automatically.
      placeholder: Auto-generate
    qr:
      title: Connect from Stage Pocket
      description: >-
        Scan this QR code from Stage Pocket to try all reachable local network addresses and save the first working one.
      refresh: Refresh
      image-alt: Aura server channel connection QR code
      candidates: Candidate addresses
      token-hint: >-
        The QR code includes the auth token so Stage Pocket can authenticate after connecting. Do not share it publicly.
      errors:
        title: QR code unavailable
        unavailable: Failed to prepare the connection QR code.
    qr-scan:
      title: Quick Connect
      description: Scan the QR code from Tamagotchi to quick connect
      instructions: Point the camera at the Aura connection QR code.
      action: Scan
      success:
        title: Connected address saved
        description: 'URL been used: {url}'
      errors:
        title: QR scan failed
        failed: Failed to scan or connect with the QR code.
  system:
    color-scheme:
      description: Đổi bảng màu sân khấu.
      title: Bảng màu
    developer:
      description: Một số tùy chọn cho nhà phát triển.
      title: Nhà phát triển
    general:
      description: Chế độ tối, ngôn ngữ, v.v.
      title: Chung
    description: Tùy chỉnh thiết lập bối cảnh của bạn!
    sections:
      section:
        custom-color:
          fields:
            field:
              primary-color:
                label: Màu chính
                rgb-on:
                  title: Tôi muốn nó động!
          title: Bảng màu
        developer:
          title: Nhà phát triển
          sections:
            section:
              performance-visualizer:
                title: Trực quan hiệu năng
                description: Bật/Tắt lớp phủ FPS/tác vụ dài/bộ nhớ
              markdown-stress:
                title: Kiểm thử Markdown
                description: Thử nghiệm phân tích Markdown với hội thoại lớn
              use-magic-keys:
                title: Công cụ useMagicKeys
                description: Kiểm tra các phím tắt
              audio-record:
                title: Ghi âm
                description: Kiểm tra các tính năng liên quan đến âm thanh
              background-gradient-blending:
                title: Hòa trộn màu nền
                description: Kiểm tra hòa trộn và chủ đề
              background-removal:
                title: Xóa nền (Yêu cầu WebGPU)
                description: Công cụ hỗ trợ xóa nền
              chat:
                title: Trò chuyện
                description: Thử nghiệm hội thoại
              gesture-circle:
                title: Vòng tròn cử chỉ (Chỉ Desktop)
                description: Kiểm tra nhận diện cử chỉ
              image:
                title: Hình ảnh
                description: Xử lý hình ảnh
              polaroid:
                title: Polaroid
                description: Công cụ chụp ảnh mô hình
              context-flow:
                description: >-
                  Kiểm tra các bản cập nhật ngữ cảnh và sự kiện luồng chat
              websocket-inspector:
                title: Kiểm tra WebSocket
                description: Theo dõi lưu lượng WebSocket thô
              vibrant:
                title: Trích xuất màu
                description: Thử nghiệm trích xuất màu sắc
              providers-transcription-realtime-aliyun-nls:
                title: Aliyun Real-time Transcriber
                description: >-
                  Truyền âm thanh micro tới Aliyun NLS và kiểm tra văn bản trực tiếp
              performance-playground:
                title: Khu thử nghiệm hiệu năng
                description: VRM expressions + TTS lip sync playground
        theme-presets:
          presets:
            default:
              colors:
                color-1: Xanh Aura
              description: Màu xanh lá mặc định do Aura mang đến cho bạn!
              title: Màu mặc định
            morandi:
              colors:
                color-1: Nâu xám
                color-2: Be
                color-3: Xám tro
                color-4: Nâu nhạt
                color-5: Ngà
                color-6: Xám ô liu
                color-7: Cát
                color-8: Xám ấm
              description: Tông màu mềm mại lấy cảm hứng từ tranh của Giorgio Morandi
              title: Màu Morandi
            monet:
              colors:
                color-1: Xanh da trời
                color-2: Sương mù
                color-3: Cát
                color-4: Xanh rêu
                color-5: Hoa súng
                color-6: Lúa mì
                color-7: Xanh đá phiến
                color-8: Xanh xô thơm
              description: Bảng màu ấn tượng lấy cảm hứng từ tác phẩm của Claude Monet
              title: Màu Monet
            japanese:
              colors:
                color-1: Nâu da cam
                color-2: Nâu xám ấm
                color-3: Nâu đất
                color-4: Cà phê
                color-5: Đồng
                color-6: Vàng kim
                color-7: Mù tạt
                color-8: Hổ phách
              description: Bảng màu truyền thống Nhật Bản
              title: Màu Nhật Bản
            nordic:
              colors:
                color-1: Xanh Bắc Âu
                color-2: Băng
                color-3: Vịnh hẹp
                color-4: Thép
                color-5: Sông băng
                color-6: Đá phiến
                color-7: Mây
                color-8: Đá
              description: Phong cách màu tối giản vùng Scandinavia
              title: Màu Bắc Âu
            chinese:
              colors:
                color-1: Bình minh
                color-2: Đỏ Trung Hoa
                color-3: Nâu khói
                color-4: Xanh tre
                color-5: Tím đậm
                color-6: Vàng hoàng kim
                color-7: Xanh lam
                color-8: Thổ hoàng
              description: >-
                Màu sắc truyền thống Trung Hoa, lấy cảm hứng từ dệt may, gốm sứ và hội họa cổ
              title: Màu truyền thống Trung Hoa
          title: Bộ Màu Có Sẵn
    title: Giao Diện
  page:
    developers:
      open-devtools:
        title: Mở Công cụ nhà phát triển
        button: Mở
  credits:
    buy: Buy
  scene:
    title: Scenes
    description: Customize the virtual environment for your characters.
    beta_label: Scenes System
    beta_description: Each character card specifies its own preferred background from this gallery. Setting it here will set it as the default for the currently active character.
    background_image:
      title: Active Character Background
      no_background: No background active for this character. Upload a square or landscape image for best results.
      upload: Upload to Gallery
      change: Change Background
      clear: Clear Default
    gallery:
      title: Scene Gallery
      empty: No images in gallery yet. Upload one above!
      set_as_global: Set as Character Default
      delete: Delete from Gallery
      global_badge: Character Default
      active_badge: Current Scene
      delete_confirm: Are you sure you want to delete this background?
    tip:
      label: Tip!
      description: Using a square image will leverage <b>cover</b> cropping in portrait mode, focusing on the center of the scene.
sections:
  section:
    general:
      title: Chung
theme:
  title: Chủ Đề
  description: |
    Chuyển đổi chủ đề cơ bản của Aura, Chế độ Sáng hoặc Chế độ Tối.
title: Cài Đặt
voices: Giọng Nói
vrm:
  change-model:
    from-file: Tải từ Tệp
    from-file-select: Chọn
    from-url: Tải từ URL
    from-url-confirm: Tải
    from-url-placeholder: Nhập URL mô hình VRM
    title: Thay Đổi Mô Hình
  title: Cài Đặt VRM
  scale-and-position:
    model-info-title: Thông Tin Kích Thước Mô Hình
    model-info-x: Chiều Rộng (X)
    model-info-y: Chiều Dài (Y)
    model-info-z: Chiều Cao (Z)
    tips: |
      Chỉnh sửa vị trí ban đầu của mô hình VRM.
      Hệ trục tọa độ được hiển thị.
    scale: Tỷ Lệ
    x: Dịch X
    'y': Dịch Y
    z: Dịch Z
    fov: Góc Nhìn (độ)
    rotation-y: Xoay Trục Y
    camera-distance: Khoảng Cách Camera
    eye-tracking-mode:
      title: Nhìn Vào
      options:
        option:
          camera: Camera
          mouse: Chuột
          disabled: Tắt
  switch-to-vrm:
    title: Chuyển sang mô hình Live2D?
    change-to-vrm: Nhấn vào đây để chuyển sang cài đặt Live2D avatar
  theme-color-from-model:
    button-extract:
      title: Trích Xuất
  skybox:
    skybox-intensity: Cường Độ SkyBox
    skybox-specular-mix: Độ Trộn Phản Chiếu
spine:
  title: Spine Settings
  scale-and-position:
    title: Scale And Position
    scale: Scale
    x: X
    'y': 'Y'
  theme-color-from-model:
    title: Extract colors from model
    button-extract:
      title: Extract
  animation:
    title: Animation
    idle-animation: Idle Animation
    mix-duration: Mix Duration (seconds)
    speed: Animation Speed
  appearance:
    title: Diện mạo
  variant:
    title: Variant
    current-variant: Active Variant
  skin:
    title: Skin
    current-skin: Current Skin
  rendering:
    title: Rendering
    max-fps: Maximum FPS
    render-scale: Render Scale
  fps:
    options:
      unlimited: Unlimited
mmd:
  title: MMD Settings
  scale-and-position:
    title: Scale And Position
    scale: Scale
    x: X
    'y': 'Y'
    rotation: Rotation
  theme-color-from-model:
    title: Extract colors from model
    button-extract:
      title: Extract
  physics:
    title: Physics & Rig
    enabled: Enable physics (hair, skirt, accessories)
    ik: Enable IK (inverse kinematics)
    grant: Enable append-bone propagation
    gravity: Gravity strength
  gaze:
    title: Gaze
    tracking: Looking at
    options:
      cursor: Mouse
      camera: Camera
      none: Disabled
  animation:
    title: Animation
    idle-motion: Idle Motion
    import-motion: Import Motion (.vmd)
    play-once: Preview Animation
    remove: Remove motion
    description: >-
      Import VMD motion files, set one as the looping idle, or play any as a one-shot gesture. Map emotions to motions to play gestures alongside facial expressions.
  morphs:
    title: Morphs
    auto: (auto)
    revert: Revert to auto
    no-morphs: This model exposes no morphs.
    description: >-
      The renderer auto-detects standard Japanese morph names (あいうえお, まばたき). Override a slot here if your model uses non-standard names.
  materials:
    title: Materials
    no-materials: This model exposes no materials.
    description: >-
      Adjust the opacity of individual model parts (face, hair, clothing, accessories). Set a part to 0 to hide it.
tachie:
  title: Tachie Settings
  archive-description: Tachie models use .tachie.zip archives containing emotion-named images.
  scale-and-position:
    title: Scale And Position
    scale: Scale
    x: X
    'y': 'Y'
  theme-color-from-model:
    title: Extract colors from model
    button-extract:
      title: Extract
  rendering:
    title: Rendering
    render-scale: Render Scale
    shadow: Theme-colored drop shadow
websocket-secure-enabled:
  title: Bật WebSocket bảo mật (WSS)
  description: >-
    Bật WSS để hỗ trợ kết nối HTTPS cho thiết bị di động trong quá trình phát triển. Chứng chỉ tự ký sẽ được tạo tự động.
wip:
  title: Đang phát triển
  description: >-
    Tính năng này hiện đang được hoàn thiện và chưa sẵn sàng công khai. Hãy chờ bản cập nhật trong tương lai nhé!
